/** German is the source catalog. The other catalogs must have exactly the same keys. */
export const de = {
  app: { name: "divespots.ch", srTitle: "divespots.ch: Tauchplätze der Schweiz" },
  common: { close: "Schliessen", loading: "Lädt …", retry: "Erneut versuchen" },
  diver: {
    title: "Konto",
    nav: "Konto-Navigation",
    nav_account: "Mein Konto",
    nav_suggestions: "Meine Vorschläge",
    signIn: "Anmelden",
    signOut: "Abmelden",
    menu: "Konto von {{name}}",
    signOutFailed: "Abmelden hat nicht geklappt. Bitte versuche es erneut.",
    staffDirectTitle: "Direkt bearbeiten",
    signOutOffline: "Abmelden braucht eine Verbindung.",
    staffDirect: "Als Moderator bearbeitest du direkt.",
    staffDirectLink: "Zum Admin-Bereich",
    needsConnection: "Diese Seite braucht eine Verbindung.",
    login: {
      title: "Anmelden",
      lead: "Wir schicken dir einen Link per E-Mail. Mit Passkey oder Passwort geht es auch.",
      registerTitle: "Konto erstellen",
      registerLead:
        "Gib deine E-Mail-Adresse an. Wir schicken dir einen Link, mit dem dein Konto angelegt wird.",
      registerSend: "Konto erstellen",
      toRegister: "Noch kein Konto? Registrieren",
      toSignIn: "Schon ein Konto? Anmelden",
      email: "E-Mail",
      name: "Anzeigename",
      nameHint: "Nur für ein neues Konto, zum Beispiel dein Vorname. Du kannst ihn später ändern.",
      send: "Link per E-Mail senden",
      passkey: "Mit Passkey anmelden",
      sentTitle: "Schau in dein Postfach",
      sentText:
        "Wir haben einen Link an {{email}} geschickt. Er gilt 5 Minuten. Öffne ihn auf diesem Gerät.",
      devHint: "Entwicklung: Der Link steht in der Konsole der API.",
      otherEmail: "Andere Adresse verwenden",
      badEmail: "Bitte eine gültige E-Mail-Adresse eingeben.",
      banned: "Konto gesperrt.",
      password: "Mit Passwort anmelden",
      passwordLabel: "Passwort",
      passwordSubmit: "Anmelden",
      wrongCredentials: "E-Mail oder Passwort falsch",
      passwordMissing: "Bitte E-Mail und Passwort eingeben.",
      registrationClosed:
        "Neue Registrierungen sind zurzeit geschlossen. Bestehende Konten können sich weiterhin anmelden.",
      rateLimited: "Zu viele Versuche. Bitte warte einen Moment.",
      network: "Keine Verbindung. Bitte versuche es erneut.",
      failed: "Das hat nicht geklappt. Der Link ist vielleicht abgelaufen oder ungültig.",
    },
    account: {
      title: "Mein Konto",
      profile: "Profil",
      name: "Anzeigename",
      nameHint: "Wird bei deinen Vorschlägen angezeigt.",
      nameInvalid: "Bitte 1 bis 120 Zeichen eingeben.",
      passkeys: "Passkeys",
      passkeyLead:
        "Mit einem Passkey meldest du dich ohne Link an, per Fingerabdruck, Gesicht oder Gerätecode.",
      passkeySetup: "Passkey einrichten",
      passkeyNone: "Noch kein Passkey eingerichtet.",
      passkeyUnnamed: "Passkey",
      passkeyRemove: "Passkey {{name}} entfernen",
      passkeyAdded: "Passkey eingerichtet.",
      passkeyFailed: "Der Passkey konnte nicht eingerichtet werden.",
      passkeyUnsupported: "Dieses Gerät oder dieser Browser unterstützt keine Passkeys.",
      offerTitle: "Passkey einrichten?",
      offerText: "Beim nächsten Mal meldest du dich damit direkt an, ohne E-Mail.",
      later: "Später",
      session: "Sitzung",
      dangerTitle: "Konto löschen",
      dangerText:
        "Dein Konto und deine Anmeldedaten werden gelöscht. Deine Vorschläge und Sichtungsmeldungen bleiben anonym erhalten.",
      delete: "Konto löschen",
      deleteTitle: "Konto wirklich löschen?",
      deleteBody:
        "Das lässt sich nicht rückgängig machen. Deine Vorschläge bleiben unter «Gelöschtes Konto» erhalten, offene werden zurückgezogen. Deine Sichtungsmeldungen bleiben anonym bestehen.",
      deleteConfirm: "Endgültig löschen",
      deleteStaff:
        "Teamkonten können nicht selbst gelöscht werden. Ein Admin muss dich zuerst zurückstufen.",
    },
    suggestions: {
      title: "Meine Vorschläge",
      empty:
        "Du hast noch nichts vorgeschlagen. Öffne einen Tauchplatz und tippe auf «Änderung vorschlagen», oder schlage einen neuen Tauchplatz vor.",
    },
  },
  suggest: {
    lead: "Dein Vorschlag wird vom Team geprüft, bevor er sichtbar wird.",
    editLead:
      "Ändere, was nicht stimmt. Es werden nur die geänderten Felder vorgeschlagen. Das Team prüft sie, bevor sie sichtbar werden.",
    spotButton: "Tauchplatz vorschlagen",
    spotTitle: "Neuen Tauchplatz vorschlagen",
    editSpotButton: "Änderung vorschlagen",
    editSpotTitle: "Änderung vorschlagen: {{name}}",
    objectButton: "Objekt vorschlagen",
    objectTitle: "Objekt vorschlagen: {{name}}",
    objectHere: "Objekt hier vorschlagen",
    editObjectButton: "Objekt-Änderung vorschlagen",
    editObjectTitle: "Objekt-Änderung vorschlagen: {{name}}",
    loginHint: "Anmelden, um Sichtungen zu melden oder etwas vorzuschlagen",
    noteTitle: "Hinweis fürs Team",
    note: "Hinweis",
    noteHint: "Optional: Woher weisst du das?",
    noteHintEdit: "Pflicht: Was hast du geändert und warum?",
    send: "Vorschlag senden",
    thanks: "Danke! Dein Vorschlag wartet auf die Prüfung.",
    err: {
      tooMany:
        "Zu viele offene Vorschläge. Warte, bis das Team einige geprüft hat, oder ziehe welche zurück.",
      gone: "Das gibt es nicht mehr oder es ist nicht öffentlich.",
      noteRequired: "Bitte einen Hinweis eingeben.",
      nothingChanged: "Du hast noch nichts geändert.",
    },
    status: {
      pending: "In Prüfung",
      approved: "Übernommen",
      rejected: "Abgelehnt",
      withdrawn: "Zurückgezogen",
    },
    kind: {
      spot_create: "Neuer Tauchplatz",
      object_create: "Neues Objekt",
      spot_edit: "Änderung an einem Tauchplatz",
      object_edit: "Änderung an einem Objekt",
    },
    reason: "Begründung",
    withdraw: "Zurückziehen",
    withdrawNamed: "Vorschlag «{{name}}» zurückziehen",
    withdrawTitle: "Vorschlag zurückziehen?",
    withdrawBody: "Das Team sieht ihn dann nicht mehr.",
    more: "Mehr laden",
    openSpot: "Tauchplatz öffnen",
    openObject: "Tauchplatz mit dem Objekt öffnen",
  },
  review: {
    title: "Vorschläge",
    filterStatus: "Status",
    filterKind: "Art",
    filterSubmitter: "Eingereicht von",
    empty: "Keine Vorschläge.",
    back: "Zur Liste",
    pendingCount_one: "{{count}} offener Vorschlag",
    pendingCount_other: "{{count}} offene Vorschläge",
    stale:
      "Veraltet: Das Ziel wurde seit dem Vorschlag geändert. Prüfe den Vergleich genau, bevor du übernimmst.",
    targetGone: "Das Ziel dieser Änderung existiert nicht mehr.",
    diff: "Vergleich",
    field: "Feld",
    before: "Aktuell",
    after: "Vorschlag",
    value: "Wert",
    empty_value: "leer",
    approveTitle: "Übernehmen",
    publish: "Direkt veröffentlichen (sonst als Entwurf)",
    reason: "Begründung",
    reasonHint: "Optional. Der Taucher sieht sie.",
    adjust: "Vor dem Übernehmen anpassen",
    force: "Trotzdem übernehmen, obwohl veraltet",
    approve: "Übernehmen",
    rejectTitle: "Ablehnen",
    rejectHint: "Pflicht. Der Taucher sieht die Begründung.",
    reject: "Ablehnen",
    outcome: "Ergebnis",
    adjustedNote: "Vom Team vor dem Übernehmen angepasst.",
    err: {
      conflict:
        "Das hat sich inzwischen geändert (veraltet oder schon bearbeitet). Lade die Seite neu.",
      badPayload: "Der angepasste Vorschlag ist ungültig.",
      reasonRequired: "Bitte eine Begründung eingeben.",
    },
    keys: {
      name: "Name",
      location: "Einstieg",
      parkingLocation: "Parkplatz",
      waterBody: "Gewässer",
      locality: "Ort",
      difficulty: "Schwierigkeit",
      maxDepthM: "Maximale Tiefe (m)",
      closedPeriods: "Sperrzeiten",
      ratings: "Bewertungen",
      description: "Beschreibung",
      access: "Zugang",
      parking: "Parkplatz (Text)",
      entry: "Einstieg (Text)",
      hazards: "Gefahren",
      restrictions: "Einschränkungen",
      facilities: "Infrastruktur",
      type: "Typ",
      depthOverrideM: "Gemessene Tiefe",
      spotId: "Tauchplatz",
    },
  },
  sighting: {
    none: "Noch keine Meldung",
    lastSeen: "Zuletzt gesehen: {{date}}",
    lastMissing: "Zuletzt als fehlend gemeldet: {{date}}",
    count_one: "{{count}} Meldung",
    count_other: "{{count}} Meldungen",
    seenToday: "Heute gesehen",
    seenOn: "Gesehen am {{date}}",
    gone: "Nicht mehr da",
    seenNamed: "{{name}}: heute gesehen melden",
    goneNamed: "{{name}}: nicht mehr da melden",
    otherDay: "Anderer Tag (optional)",
    history: "Verlauf",
    statusSeen: "gesehen",
    statusGone: "fehlt",
    thanks: "Danke für deine Meldung!",
    badDate: "Das Datum ist ungültig (nicht in der Zukunft, höchstens 2 Jahre zurück).",
    tooMany: "Zu viele Meldungen. Bitte warte kurz.",
  },
  offline: {
    badge: "Offline",
    save: "Offline speichern",
    saved: "Offline gespeichert",
    estimate: "Karten, 3D-Seegrund und Luftbild: ca. {{size}}.",
    confirm: "Speichern",
    cancel: "Abbrechen",
    saving: "Wird gespeichert … {{percent}} %",
    progress: "Fortschritt des Speicherns",
    remove: "Entfernen",
    removeNamed: "{{name}} aus dem Offline-Speicher entfernen",
    listTitle: "Offline gespeichert",
    empty: "Noch nichts gespeichert. Öffne einen Tauchplatz und tippe auf «Offline speichern».",
    open: "Öffnen",
    total_one: "{{count}} Tauchplatz · {{size}}",
    total_other: "{{count}} Tauchplätze · {{size}}",
    unavailable: "Nicht offline verfügbar",
    unavailableText:
      "Dieser Tauchplatz wurde nicht gespeichert. Mit Verbindung kannst du ihn für offline speichern.",
    adminNeedsConnection: "Admin braucht eine Verbindung",
    error: {
      quota:
        "Nicht genug Speicherplatz auf diesem Gerät. Entferne gespeicherte Tauchplätze und versuche es erneut.",
      network: "Keine Verbindung. Das Speichern wurde abgebrochen.",
      failed: "Das Speichern hat nicht geklappt. Bitte versuche es erneut.",
    },
  },
  pwa: { updateAvailable: "Neue Version verfügbar", reload: "Neu laden" },
  minimap: {
    title: "Seekarte",
    hide: "Seekarte ausblenden",
    show: "Seekarte anzeigen",
    openSpot: "Zum Tauchplatz {{name}}",
    object: "Objekt {{name}}",
    currentSpot: "{{name}}: aktueller Tauchplatz",
  },
  diveAccess: {
    chunkFailed: "Der Tauchmodus konnte nicht geladen werden.",
    reload: "Neu laden",
    loadFailed: "Konnte nicht geladen werden. Bitte versuche es erneut.",
    button: "Tauchmodus (Beta)",
    unavailableTitle: "Nicht verfügbar",
    unavailable: "Diese Seite ist nicht verfügbar.",
    back: "Zur Karte",
  },
  course: {
    same: "Gleiches Objekt",
    title: "Kurs",
    from: "Kurs von {{name}}",
    to: "nach",
    pick: "Ziel wählen.",
    pickPin: "Oder tippe einen Pin an.",
    noOthers: "Keine weiteren Objekte.",
    fromHere: "Kurs von hier …",
    action: "Kurs",
    rowFrom: "Kurs von {{name}} berechnen",
    rowTo: "Kurs von {{from}} nach {{name}}",
    asDestination: "Als Ziel",
    swap: "Start und Ziel tauschen",
    close: "Kurs schliessen",
    computing: "Berechnet …",
    unavailable: "Kurs nicht verfügbar",
    compass: "Kompass",
    true: "geografisch {{deg}}°",
    declination: "Missweisung {{value}}",
    distance: "Distanz",
    depth: "Tiefe",
    depthUnknown: "Tiefe unbekannt",
    slope: "Schräg",
    back: "Rückweg",
    east: "O",
    west: "W",
    footnote:
      "Orientierungshilfe aus den erfassten Positionen (± einige Meter). Ersetzt keine Tauchgangsplanung.",
  },
  menu: {
    open: "Menü",
    title: "Menü",
    close: "Menü schliessen",
  },
  language: { label: "Sprache", de: "Deutsch", en: "English", fr: "Français", it: "Italiano" },
  search: {
    label: "Tauchplatz oder See suchen",
    placeholder: "Tauchplatz oder See suchen",
    clear: "Suche leeren",
    noResults: "Keine Tauchplätze gefunden",
    results_one: "{{count}} Treffer",
    results_other: "{{count}} Treffer",
  },
  lakeFilter: { label: "See filtern", all: "Alle Seen" },
  map: {
    controls: "Kartensteuerung",
    label: "Karte der Tauchplätze",
    layerLabel: "Kartenebene",
    layerMap: "Karte",
    layerAerial: "Luftbild",
    zoomIn: "Hineinzoomen",
    zoomOut: "Herauszoomen",
    locate: "Mein Standort",
    locateDenied: "Standort nicht freigegeben. Erlaube den Zugriff in den Browser-Einstellungen.",
    locateUnavailable: "Standort nicht verfügbar.",
    locateOutside: "Dein Standort liegt ausserhalb der Karte.",
    spotPin: "Tauchplatz {{name}}",
    spotPinClosed: "Tauchplatz {{name}}, geschlossen",
    spotPinPermanent: "Tauchplatz {{name}}, dauerhaft geschlossen",
    cluster: "{{count}} Tauchplätze, zum Hineinzoomen tippen",
    loadError: "Die Tauchplätze konnten nicht geladen werden.",
    attribution: "© swisstopo",
    scale: "Massstab: {{distance}}",
  },
  wind: {
    toggle: "Wind",
    info: "Informationen zur Windvorhersage",
    offline: "Wind braucht eine Internetverbindung",
    label: "Windvorhersage",
    time: "Vorhersagezeit",
    now: "Jetzt",
    model: "Modellprognose, Seehöhe",
    run: "Modelllauf {{time}}",
    placeCenter: "Kartenmitte",
    readout: "{{place}}: {{kmh}} km/h aus {{dir}}",
    readoutNone: "{{place}}: keine Daten",
    readoutCalm: "{{place}}: windstill",
    dir: { n: "N", ne: "NO", e: "O", se: "SO", s: "S", sw: "SW", w: "W", nw: "NW" },
    creditShort: "Wind:",
    creditMeteo: "MeteoSwiss via",
    chip: "Modell",
    creditVia: "Wind: MeteoSwiss ICON-CH via",
    interpolated: "interpoliert",
    legend: "Windstärke in km/h",
    loading: "Wind wird geladen …",
    unavailable: "Wind ist vorübergehend nicht verfügbar.",
  },
  precip: {
    toggle: "Niederschlag",
    info: "Informationen zur Niederschlagsvorhersage",
    offline: "Niederschlag braucht eine Internetverbindung",
    infoBoth: "Informationen zur Wind- und Niederschlagsvorhersage",
    label: "Niederschlagsvorhersage",
    labelBoth: "Wind- und Niederschlagsvorhersage",
    legend: "Regen und Schnee",
    class0: "leicht",
    class1: "mässig",
    class2: "stark",
    class3: "sehr stark",
    hours: "{{from}}–{{to}} Uhr",
    readout: "{{place}}: Niederschlag: {{hours}} {{mm}} mm/h",
    readoutDry: "{{place}}: {{hours}} kein Niederschlag",
    readoutNone: "{{place}}: Niederschlag: keine Daten",
    model: "Modell, kein Radar",
    creditShort: "Niederschlag:",
    creditBoth: "Wind/Niederschlag:",
    creditVia: "Niederschlag: MeteoSwiss ICON-CH via",
    creditViaBoth: "Wind/Niederschlag: MeteoSwiss ICON-CH via",
    loading: "Niederschlag wird geladen …",
    unavailable: "Niederschlag ist vorübergehend nicht verfügbar.",
  },
  sheet: {
    expandPanel: "Seitenleiste ausklappen",
    collapsePanel: "Seitenleiste einklappen",
    grabber: "Höhe des Panels ändern",
    detentPeek: "Klein",
    detentMedium: "Mittel",
    detentLarge: "Gross",
    notFoundTitle: "Tauchplatz nicht gefunden",
    notFoundText: "Diesen Tauchplatz gibt es nicht oder er ist nicht öffentlich.",
    backToMap: "Zur Karte",
    loadError: "Der Tauchplatz konnte nicht geladen werden.",
  },
  spot: {
    place: "{{locality}} · {{waterBody}}",
    view: "Ansicht",
    view2d: "2D",
    view3d: "3D",
    noBathy: "Keine Seegrund-Daten",
    closedNowUntil: "Geschlossen bis {{date}}",
    closedNowReason: "Geschlossen: {{reason}} bis {{date}}",
    closedForGood: "Dauerhaft geschlossen",
    closedForGoodSince: "Dauerhaft geschlossen seit {{date}}",
    closedForGoodReason: "Grund: {{reason}}",
    maxDepthBadge: "Max. {{value}}",
    objectCount_one: "{{count}} Objekt",
    objectCount_other: "{{count}} Objekte",
  },
  difficulty: {
    very_easy: "Sehr einfach",
    easy: "Einfach",
    medium: "Mittel",
    hard: "Schwer",
    very_hard: "Sehr schwer",
  },
  facts: {
    title: "Fakten",
    difficulty: "Schwierigkeit",
    maxDepth: "Max. Tiefe",
    waterBody: "Gewässer",
    locality: "Ort",
    waterLevel: "Wasserspiegel",
    waterLevelValue: "{{value}} ü. M.",
    entry: "Einstieg",
    parking: "Parkplatz",
  },
  objects: {
    title: "Objekte",
    unnamed: "Objekt ohne Namen",
    outside: "ausserhalb des Ausschnitts — Radius vergrössern",
    noData: "Keine Daten",
    approx: "ca.",
    provenance: "≈ aus dem Seegrund-Modell swissBATHY3D berechnet, ±0.5 m",
    type: {
      figure: "Figur",
      toilet: "Toilette",
      wreck: "Wrack",
      vehicle: "Fahrzeug",
      platform: "Plattform",
      plaque: "Gedenktafel",
      other: "Objekt",
    },
  },
  sections: {
    description: "Beschreibung",
    access: "Anfahrt",
    parking: "Parkplätze",
    entry: "Einstieg",
    hazards: "Gefahren",
    restrictions: "Einschränkungen",
    facilities: "Infrastruktur",
  },
  admin: {
    brand: "Admin",
    menu: "Admin-Bereich",
    nav: "Admin-Navigation",
    nav_spots: "Tauchplätze",
    nav_lakes: "Seen",
    nav_users: "Benutzer",
    nav_settings: "Einstellungen",
    nav_audit: "Protokoll",
    nav_suggestions: "Vorschläge",
    toMap: "Zur Karte",
    edit: "Bearbeiten",
    signOut: "Abmelden",
    signedInAs: "Angemeldet als {{name}}, {{role}}",
    common: {
      save: "Speichern",
      saved: "Gespeichert.",
      cancel: "Abbrechen",
      delete: "Löschen",
      edit: "Bearbeiten",
    },
    role: { admin: "Admin", moderator: "Moderator", diver: "Taucher" },
    status: {
      all: "Alle",
      draft: "Entwurf",
      published: "Veröffentlicht",
      pending: "Ausstehend",
    },
    login: {
      title: "Anmelden",
      lead: "Nur für Moderatoren und Admins. Konten legt ein Admin an.",
      email: "E-Mail",
      password: "Passwort",
      submit: "Anmelden",
      missing: "Bitte E-Mail und Passwort eingeben.",
      invalid: "E-Mail oder Passwort stimmt nicht.",
      banned: "Dieses Konto ist gesperrt.",
      rateLimited: "Zu viele Versuche. Bitte versuche es später noch einmal.",
      failed: "Anmeldung fehlgeschlagen. Bitte versuche es erneut.",
      fixtures: "Die Anmeldung braucht die echte API (nicht den Fixture-Modus).",
    },
    forbidden: {
      staffOnly: "Dieser Bereich ist nur für das Team.",
      title: "Kein Zugriff",
      body: "Diese Seite ist nur für Admins.",
      back: "Zu den Tauchplätzen",
    },
    discard: {
      title: "Änderungen verwerfen?",
      body: "Deine Änderungen wurden noch nicht gespeichert und gehen verloren.",
      confirm: "Verwerfen",
      keep: "Weiter bearbeiten",
    },
    err: {
      concurrent: "Inzwischen von jemand anderem geändert — Werte aktualisiert.",
      load: "Die Daten konnten nicht geladen werden.",
      save: "Das hat nicht geklappt. Bitte versuche es erneut.",
      fix: "Bitte korrigiere die markierten Felder.",
      auth: "Deine Sitzung ist abgelaufen oder es fehlt die Berechtigung. Bitte melde dich neu an.",
      required: "Pflichtfeld.",
      invalid: "Ungültiger Wert.",
      slug: "Nur Kleinbuchstaben, Ziffern und einzelne Bindestriche.",
      slugTaken: "Dieser Slug ist schon vergeben.",
      coords: "Gültige Koordinate eingeben (Dezimalgrad).",
      mmdd: "Format MM-TT, zum Beispiel 11-15.",
      nameRequired: "Mindestens eine Übersetzung eingeben.",
    },
    i18n: {
      language: "Sprache der Texte",
      missing: "Übersetzung fehlt",
      missingHint: "Auf Deutsch vorhanden, {{lang}} fehlt noch.",
    },
    spots: {
      title: "Tauchplätze",
      new: "Neuer Tauchplatz",
      create: "Tauchplatz anlegen",
      edit: "{{name}} bearbeiten",
      formLabel: "Tauchplatz-Formular",
      filters: "Filter",
      search: "Suchen",
      count_one: "{{count}} Tauchplatz",
      count_other: "{{count}} Tauchplätze",
      drafts_one: "{{count}} Entwurf",
      drafts_other: "{{count}} Entwürfe",
      empty: "Keine Tauchplätze für diesen Filter.",
      open: "{{name}} öffnen",
      notFound: "Tauchplatz nicht gefunden",
      backToList: "Zur Liste",
      viewPublic: "Öffentliche Seite",
      publish: "Veröffentlichen",
      unpublish: "Zurück auf Entwurf",
      delete: "Tauchplatz löschen",
      deleteTitle: "Tauchplatz löschen?",
      deleteBody:
        "«{{name}}» und seine Objekte verschwinden von der Karte. Das lässt sich hier nicht rückgängig machen.",
      deleteConfirm: "Endgültig löschen",
      draftNote: "Dieser Tauchplatz ist ein Entwurf und auf der öffentlichen Karte unsichtbar.",
    },
    section: {
      basics: "Grunddaten",
      location: "Lage",
      texts: "Texte",
      closed: "Sperrzeiten",
      permanent: "Dauerhafte Schliessung",
      ratings: "Bewertungen",
      publication: "Veröffentlichung",
    },
    field: {
      name: "Name",
      slug: "Slug (optional)",
      slugDerived: "Leer lassen: wird «{{slug}}».",
      slugHint: "Teil der Adresse, zum Beispiel /de/spot/…",
      waterBody: "Gewässer",
      locality: "Ort",
      difficulty: "Schwierigkeit",
      none: "Keine Angabe",
      maxDepth: "Maximale Tiefe (m)",
      status: "Status",
      entry: "Einstiegspunkt",
      hasParking: "Parkplatz angeben",
      parking: "Parkplatz",
      lake: "See: {{name}}",
      noLake: "Keinem See zugeordnet",
      hasBathy: "mit Seegrund-Daten",
    },
    picker: {
      help: "Tippe auf die Karte oder ziehe den Pin. Alternativ die Koordinaten eingeben.",
      lat: "Breite (lat)",
      lon: "Länge (lon)",
    },
    depth: {
      pick: "Wähle einen Punkt, um die Tiefe zu sehen.",
      ok: "Tiefe aus swissBATHY3D: ≈ {{depth}}",
      dry: "Dieser Punkt liegt über dem Wasserspiegel.",
      noData: "Keine Seegrund-Daten an diesem Punkt.",
      noLake: "Kein See mit Seegrund-Daten an diesem Punkt.",
      error: "Die Tiefe konnte nicht abgefragt werden.",
    },
    permanent: {
      toggle: "Dauerhaft geschlossen",
      help: "Für Tauchplätze, die nicht mehr betaucht werden dürfen. Sie bleiben sichtbar und sind als geschlossen markiert.",
      since: "Seit (JJJJ-MM-TT, optional)",
      reason: "Grund",
      marker: "Dauerhaft geschlossen",
    },
    closed: {
      help: "Jährlich wiederkehrend. Von nach Bis darf über den Jahreswechsel gehen, zum Beispiel 11-15 bis 02-28.",
      none: "Keine Sperrzeiten.",
      add: "Sperrzeit hinzufügen",
      period: "Sperrzeit {{n}}",
      from: "Von (MM-TT)",
      to: "Bis (MM-TT)",
      reason: "Grund",
      remove: "Sperrzeit {{n}} entfernen",
    },
    ratings: { clear: "Leeren" },
    objects: {
      title: "Objekte",
      add: "Objekt hinzufügen",
      none: "Noch keine Objekte.",
      afterCreate: "Objekte kannst du hinzufügen, sobald der Tauchplatz angelegt ist.",
      addTitle: "Neues Objekt",
      editTitle: "Objekt bearbeiten",
      edit: "Objekt {{name}} bearbeiten",
      delete: "Objekt {{name}} löschen",
      deleteTitle: "Objekt löschen?",
      deleteBody: "«{{name}}» wird gelöscht.",
      type: "Typ",
      name: "Name",
      description: "Beschreibung",
      location: "Position des Objekts",
      override: "Gemessene Tiefe (m)",
      overrideHint: "Optional. Leer lassen, dann gilt die berechnete Tiefe (mit ≈).",
    },
    lakes: {
      title: "Seen",
      level: "Wasserspiegel",
      levelInput: "Wasserspiegel (m ü. M.)",
      bathy: "mit Seegrund-Daten",
      edit: "Wasserspiegel von {{name}} ändern",
      invalid: "Bitte eine Zahl zwischen 0 und 5000 eingeben.",
      warning: "Beim Speichern werden die Tiefen aller Objekte in diesem See neu berechnet.",
    },
    settings: {
      title: "Einstellungen",
      registration: "Registrierung",
      allow: "Neue Registrierungen erlauben",
      max: "Max. neue Konten pro Stunde",
      maxHint: "0 = keine neuen Konten. Gilt für alle zusammen, in jeder Stunde.",
      maxInvalid: "Bitte eine ganze Zahl von 0 bis 1000 eingeben.",
      newLastHour: "Neue Konten (letzte Stunde)",
      refusedLastHour: "Abgewiesene Registrierungen (letzte Stunde)",
      noMail: "Kein E-Mail-Versand eingerichtet — Registrierung kann nicht geöffnet werden",
      mailConflict:
        "Die Registrierung konnte nicht geöffnet werden: Es ist kein E-Mail-Versand eingerichtet.",
      save: "Speichern",
      saved: "Gespeichert.",
      updatedAt: "Zuletzt geändert: {{date}}",
    },
    model: {
      title: "3D-Modell",
      save: "Modell speichern",
      none: "Kein 3D-Modell hochgeladen.",
      choose: "Datei wählen",
      replace: "Modell ersetzen",
      file: ".glb-Datei",
      drop: ".glb-Datei hierher ziehen oder auswählen (höchstens {{max}} MB).",
      chosen: "{{name}} ({{size}}), noch nicht hochgeladen",
      attribution: "Quelle / Lizenz",
      attributionHint:
        "Wer hat das Modell gemacht, unter welcher Lizenz? Wird im Tauchmodus angezeigt.",
      scale: "Skalierung",
      heading: "Ausrichtung (°)",
      headingHint: "0 bis unter 360, Blickrichtung der Vorderseite, im Uhrzeigersinn ab Norden.",
      discard: "Auswahl verwerfen",
      discardBody: "Die Änderungen am 3D-Modell sind noch nicht gespeichert und gehen verloren.",
      headingShort: "Ausrichtung",
      upload: "Hochladen",
      remove: "Modell löschen",
      removeTitle: "Modell löschen?",
      removeBody: "Das 3D-Modell dieses Objekts wird entfernt. Das Objekt bleibt bestehen.",
      uploaded: "Modell hochgeladen.",
      saved: "Gespeichert.",
      deleted: "Modell gelöscht.",
      size: "Grösse",
      triangles: "Dreiecke",
      bounds: "Abmessungen",
      animations: "Animationen",
      preview: "Vorschau des 3D-Modells",
      previewLoading: "Vorschau lädt …",
      previewFailed: "Vorschau nicht möglich.",
      north: "N",
      err: {
        extension: "Nur .glb-Dateien (glTF binär) sind erlaubt.",
        empty: "Die Datei ist leer.",
        size: "Die Datei ist grösser als 8 MB.",
        magic: "Das ist keine gültige .glb-Datei.",
        tooLarge: "Die Datei ist zu gross (höchstens 8 MB).",
        forbidden: "Nur Admins können 3D-Modelle ändern.",
        rateLimited: "Zu viele Uploads. Bitte einen Moment warten.",
        notFound: "Das Modell wurde inzwischen entfernt. Bitte neu laden.",
        scale: "Skalierung zwischen 0,01 und 100.",
        heading: "Ausrichtung von 0 bis unter 360.",
      },
    },
    audit: {
      title: "Protokoll",
      lead: "Wer hat wann was geändert. Nur für Admins.",
      filterEntity: "Was",
      filterAction: "Aktion",
      all: "Alle",
      when: "Zeit",
      who: "Wer",
      action: "Aktion",
      what: "Was",
      script: "Skript: {{label}}",
      deletedAccount: "Gelöschtes Konto",
      deletedTarget: "gelöscht",
      unnamed: "ohne Namen",
      sugg: "Vorschlag",
      details: "Änderungen ({{count}})",
      more: "mehr",
      less: "weniger",
      empty: "Keine Einträge gefunden.",
      count_one: "{{count}} Eintrag",
      count_other: "{{count}} Einträge",
      loadMore: "Mehr laden",
      filterBy: "Nur {{name}} zeigen",
      removeFilter: "Filter entfernen: {{name}}",
      chipSpot: "Tauchplatz: {{name}}",
      chipActor: "Von: {{name}}",
      unknownSpot: "Tauchplatz",
      unknownPerson: "Person",
      history: "Verlauf",
      yes: "ja",
      no: "nein",
      adjusted: "Mit Anpassungen angenommen",
      cascaded: "Mit dem Tauchplatz gelöscht",
      redacted: "Personendaten entfernt",
      reason: "Grund: {{text}}",
      kind: "Art: {{kind}}",
      accountDeleted: "Konto gelöscht",
      entity: {
        spot: "Tauchplatz",
        object: "Objekt",
        suggestion: "Vorschlag",
        sighting: "Sichtung",
        lake: "See",
        user: "Benutzer",
        settings: "Einstellungen",
      },
      actions: {
        create: "erstellt",
        update: "bearbeitet",
        delete: "gelöscht",
        submit: "vorgeschlagen",
        withdraw: "zurückgezogen",
        approve: "angenommen",
        reject: "abgelehnt",
      },
      field: {
        name: "Name",
        slug: "Slug",
        location: "Lage",
        waterBody: "Gewässer",
        locality: "Ort",
        difficulty: "Schwierigkeit",
        maxDepthM: "Maximale Tiefe (m)",
        closedPeriods: "Sperrzeiten",
        permanentClosure: "Dauerhafte Schliessung",
        status: "Status",
        parkingLocation: "Parkplatz-Lage",
        description: "Beschreibung",
        access: "Zugang",
        parking: "Parkplatz",
        entry: "Einstieg",
        hazards: "Gefahren",
        restrictions: "Einschränkungen",
        facilities: "Infrastruktur",
        ratings: "Bewertungen",
        ratings_fish: "Bewertung Fische",
        ratings_walls: "Bewertung Wände",
        ratings_caves: "Bewertung Höhlen",
        ratings_wrecksSculptures: "Bewertung Wracks und Skulpturen",
        ratings_current: "Bewertung Strömung",
        ratings_surroundings: "Bewertung Umgebung",
        type: "Typ",
        depthOverrideM: "Tiefe, manuell (m)",
        model: "3D-Modell",
        model_scale: "3D-Modell: Skalierung",
        model_headingDeg: "3D-Modell: Ausrichtung (°)",
        model_modelId: "3D-Modell: Datei",
        waterLevelM: "Wasserstand (m ü. M.)",
        hasBathy: "mit Seegrund-Daten",
        registrationOpen: "Registrierung offen",
        maxNewAccountsPerHour: "Neue Konten pro Stunde (max.)",
        diveAccess: "Tauchmodus",
        banned: "Gesperrt",
        role: "Rolle",
        password: "Passwort",
        present: "Noch vorhanden",
      },
      countMore_one: "{{count}} neuester Eintrag · weitere vorhanden",
      countMore_other: "{{count}} neueste Einträge · weitere vorhanden",
      fieldLabel: "{{label}}:",
      activeFilters: "Aktive Filter",
    },
    users: {
      search: "Name oder E-Mail suchen",
      filterRole: "Rolle",
      filterStatus: "Status",
      all: "Alle",
      active: "Aktiv",
      blocked: "Gesperrt",
      new24h: "Neu in den letzten 24 h",
      email: "E-Mail",
      registered: "Registriert",
      lastSeen: "Zuletzt gesehen",
      never: "nie",
      pending: "Offene Vorschläge",
      user: "Benutzer",
      pendingShort: "Offen",
      diveModeShort: "inkl.",
      diveMode: "Tauchmodus",
      diveModeOf: "Tauchmodus für {{name}}",
      diveModeAdmin: "Im Admin-Zugang enthalten",
      empty: "Keine Benutzer gefunden.",
      count: "{{count}} Benutzer",
      banTitle: "{{name}} sperren?",
      banBody: "{{name}} wird sofort überall abgemeldet und kann sich nicht mehr anmelden.",
      unbanTitle: "{{name}} entsperren?",
      unbanBody: "{{name}} kann sich wieder anmelden.",
      title: "Benutzer",
      you: "du",
      role: "Rolle",
      roleOf: "Rolle von {{name}}",
      ban: "Sperren",
      unban: "Entsperren",
      banOf: "{{name}} sperren",
      unbanOf: "{{name}} entsperren",
      banned: "Gesperrt",
      selfNote: "Eigene Rolle und Sperre nicht änderbar.",
      selfConflict: "Das geht bei deinem eigenen Konto nicht.",
      create: "Benutzer anlegen",
      createSubmit: "Benutzer anlegen",
      created: "{{email}} wurde angelegt.",
      name: "Name",
      initialPassword: "Anfangspasswort",
      passwordHint: "Mindestens 12 Zeichen. Gib es persönlich weiter, nicht per E-Mail oder Chat.",
      passwordShort: "Mindestens 12 Zeichen.",
      emailInvalid: "Gültige E-Mail-Adresse eingeben.",
      emailTaken: "Diese E-Mail-Adresse ist schon vergeben.",
    },
  },
  three: {
    shoreLeft: "Am Ufer nach links",
    shoreRight: "Am Ufer nach rechts",
    backToEntry: "Zurück zum Einstieg",
    lakeEnd: "Ende des Sees erreicht",
    shoreLost: "Ufer nicht gefunden",
    spotPin: "Tauchplatz {{name}}",
    canvas:
      "3D-Modell des Seegrunds. Ziehen zum Drehen, tippen für die Tiefe. Mit den Pfeiltasten ein Fadenkreuz über den Seegrund bewegen.",
    back2d: "2D-Ansicht",
    radius: "Radius",
    exaggeration: "Überhöhung",
    exaggerationValue: "{{value}}×",
    water: "Wasserfläche",
    planes: "Tiefenebenen",
    compassNow: "Kompass, Blickrichtung {{deg}} Grad {{name}}",
    cardinal: { N: "N", NE: "NO", E: "O", SE: "SO", S: "S", SW: "SW", W: "W", NW: "NW" },
    cardinalName: {
      N: "Nord",
      NE: "Nordost",
      E: "Ost",
      SE: "Südost",
      S: "Süd",
      SW: "Südwest",
      W: "West",
      NW: "Nordwest",
    },
    compass: "Kompass, tippen für die Ausgangsansicht",
    loading: "Seegrund wird geladen …",
    noDataHere: "Hier gibt es keine Seegrund-Daten",
    rateLimited: "Zu viele Anfragen. Bitte versuche es später noch einmal.",
    loadFailed: "Der Seegrund konnte nicht geladen werden.",
    noWebgl: "Dein Browser kann keine 3D-Grafik (WebGL) darstellen.",
    contextLost: "Die 3D-Grafik wurde unterbrochen.",
    reload: "Neu laden",
    legend: "Tiefe",
    readoutNote: "swissBATHY3D, ±0.5 m",
    readoutNoData: "Keine Daten",
    readoutLand: "Ufer",
    pinLabel: "Objekt {{name}}, {{depth}}",
    place: {
      toggle: "Objekt platzieren",
      hint: "Tippe auf den Seegrund, um ein Objekt zu platzieren.",
      movingHint: "Tippe auf den Seegrund: Ziel für «{{name}}».",
      cancel: "Abbrechen",
      move: "Verschieben",
      moveConfirmTitle: "«{{name}}» verschieben?",
      moveConfirmBody:
        "«{{name}}» wird an die getippte Stelle verschoben. Die Tiefe wird neu berechnet.",
      moveConfirm: "Verschieben",
      depthPreview: "Berechnete Tiefe: {{depth}} (Vorschau)",
      noDepth: "Keine Tiefendaten – Tiefe manuell eingeben.",
      panel: "Objekt platzieren",
    },
    objectClose: "Objektdetails schliessen",
  },
  ratings: {
    title: "Bewertungen",
    fish: "Fische",
    walls: "Wände",
    caves: "Höhlen",
    wrecksSculptures: "Wracks und Skulpturen",
    current: "Strömung",
    surroundings: "Umgebung",
    value: "{{label}}: {{value}} von 5",
  },
};
